const VAT = 0.15;
const CONVEYANCING_DISBURSEMENTS_RAND = 4000;
const ADMIN_FEES_CENTS = 1000000;

function toNum(v) {
  return Number(v) || 0;
}

function sumLineItems(items) {
  if (!Array.isArray(items)) return 0;
  return items.reduce((acc, item) => acc + toNum(item.amountCents), 0);
}

function transferFeeRand(marketValueRand) {
  if (marketValueRand <= 0) return 0;
  if (marketValueRand <= 100000) return 6435;
  if (marketValueRand <= 500000) {
    return 6435 + Math.floor((marketValueRand - 100000) / 50000) * 1025;
  }
  if (marketValueRand <= 1000000) {
    return 14635 + Math.floor((marketValueRand - 500000) / 100000) * 1985;
  }
  if (marketValueRand <= 5000000) {
    return 24560 + Math.floor((marketValueRand - 1000000) / 200000) * 1985;
  }
  return 64260 + Math.floor((marketValueRand - 5000000) / 1000000) * 5000;
}

function deedsOfficeFeeRand(marketValueRand) {
  if (marketValueRand <= 0) return 0;
  if (marketValueRand <= 100000) return 47;
  if (marketValueRand <= 200000) return 107;
  if (marketValueRand <= 300000) return 682;
  if (marketValueRand <= 600000) return 850;
  if (marketValueRand <= 800000) return 1196;
  if (marketValueRand <= 1000000) return 1374;
  if (marketValueRand <= 2000000) return 1544;
  if (marketValueRand <= 4000000) return 2140;
  if (marketValueRand <= 6000000) return 2596;
  if (marketValueRand <= 8000000) return 3092;
  if (marketValueRand <= 10000000) return 3615;
  if (marketValueRand <= 15000000) return 4303;
  if (marketValueRand <= 20000000) return 5169;
  return 6885;
}

function conveyancingFeesCents(propertiesCents) {
  const propertiesRand = propertiesCents / 100;
  const transferFee = transferFeeRand(propertiesRand);
  if (transferFee <= 0) return 0;
  const totalRand =
    transferFee +
    transferFee * VAT +
    deedsOfficeFeeRand(propertiesRand) +
    CONVEYANCING_DISBURSEMENTS_RAND;
  return Math.round(totalRand * 100);
}

export function computeOmProtect(store = {}) {
  const propertiesCents = toNum(store.propertiesCents);
  const valuablesCents = toNum(store.valuablesCents);
  const investmentsCents = toNum(store.investmentsCents);
  const businessInterestCents = toNum(store.businessInterestCents);
  const cashAndSavingsCents = toNum(store.cashAndSavingsCents);

  const homeLoansCents = toNum(store.homeLoansCents);
  const personalLoansCents = toNum(store.personalLoansCents);
  const creditCardsCents = toNum(store.creditCardsCents);
  const overdraftFacilitiesCents = toNum(store.overdraftFacilitiesCents);

  const existingCoverCents = toNum(store.existingCoverCents);
  const funeralExpensesCents = toNum(store.funeralExpensesCents);
  const bequestToSpouseCents = toNum(store.bequestToSpouseCents);
  const section4aAbatementCents = toNum(store.section4aAbatementCents);

  const executorFeePercentage = toNum(store.executorFeePercentage);

  const assetOthersSum = sumLineItems(store.assetOthers);
  const liabilityOthersSum = sumLineItems(store.liabilityOthers);
  const deductionOthersSum = sumLineItems(store.deductionOthers);

  const totalAssets =
    propertiesCents +
    valuablesCents +
    investmentsCents +
    businessInterestCents +
    cashAndSavingsCents +
    assetOthersSum;

  const totalLiabilities =
    homeLoansCents +
    personalLoansCents +
    creditCardsCents +
    overdraftFacilitiesCents +
    liabilityOthersSum;

  const netAssets = totalAssets - totalLiabilities;
  const totalValueOfAssets = netAssets + existingCoverCents;

  const grossRand = totalAssets / 100;
  let feeRand;
  if (grossRand < 250000) {
    feeRand = 10000;
  } else {
    feeRand = (executorFeePercentage / 100) * grossRand * (1 + VAT);
  }
  const executorFees = Math.round(feeRand * 100);

  const conveyancingFees = conveyancingFeesCents(propertiesCents);
  const adminFees = ADMIN_FEES_CENTS;

  const totalDeductions =
    executorFees +
    conveyancingFees +
    adminFees +
    funeralExpensesCents +
    bequestToSpouseCents +
    deductionOthersSum;

  const netEstate = totalValueOfAssets - totalDeductions;
  const dutiableEstate = Math.max(0, netEstate - section4aAbatementCents);

  const dutiableRand = dutiableEstate / 100;
  let dutyRand;
  if (dutiableRand <= 0) {
    dutyRand = 0;
  } else if (dutiableRand <= 30000000) {
    dutyRand = dutiableRand * 0.2;
  } else {
    dutyRand = 6000000 + (dutiableRand - 30000000) * 0.25;
  }
  const estateDutyPayable = Math.round(dutyRand * 100);

  const estimatedAdminCostsTotal =
    estateDutyPayable + executorFees + conveyancingFees + adminFees;

  return {
    totalAssets,
    totalLiabilities,
    netAssets,
    totalValueOfAssets,
    executorFees,
    totalDeductions,
    netEstate,
    dutiableEstate,
    estateDutyPayable,
    conveyancingFees,
    adminFees,
    estimatedAdminCostsTotal,
  };
}
